import {createSlice} from "@reduxjs/toolkit";

const initialGamesTabUserProfileNewState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  allGames: [], 
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const GamesTabUserProfileNewSlice = createSlice({
  
  name: "gamesTabUserProfileNew",
  initialState: initialGamesTabUserProfileNewState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    clearfetchStaffUsers: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.entities = [];
      state.totalCount = 0;
    },
    emptyList: (state, action) => {
      state.error = null;
      state.entities = [];
      // state.totalCount = 0;
    },
    
    contestsReportList: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
  }
});
